import React from "react";
import { Box, Typography } from "@mui/material";
import { CheckStatus } from "../../../../utils/enums";
import { CheckStatusChip } from "../../../../components/CheckStatusChip/CheckStatusChip";
import { formatDate } from "../../../../utils/dateUtils";

const ResourceStatusCell = ({ status, exceptionValidUntil, gap = 0.5, isRefreshing = false }) => {
  const normalizedStatus = status?.toLowerCase() || "";
  let displayStatus = CheckStatus.PENDING;
  
  if (normalizedStatus.includes("pass")) {
    displayStatus = CheckStatus.PASS;
  } else if (normalizedStatus.includes("fail")) {
    displayStatus = CheckStatus.FAIL;
  } else if (normalizedStatus.includes("disabled")) {
    displayStatus = CheckStatus.DISABLED;
  }
  
  return (
    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: gap }}>
      <CheckStatusChip status={displayStatus} count={0} isRefreshing={isRefreshing} />
      {exceptionValidUntil && (
        <Typography variant="caption" sx={{ color: "#6B7280", fontSize: "0.75rem", lineHeight: 1.2 }}>
          Until {formatDate(exceptionValidUntil)}
        </Typography>
      )}
    </Box>
  );
};

export default ResourceStatusCell;

